"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module  version
 * @description  This module determines the latest version of the app available.
 */

module.exports = function (config, get, post) {

	/**
	 * Gets information on the latest version of an app
	 * @param  {String}  token Optional session token
	 * @param  {String}  app   Name of app to check
	 * @param  {String}  type  Type of app (prod, dev)
	 * @return {obj}       Resolves to info on the app (version,url,etc)
	 */
	function latest(app, type) {
		return get("/version/latest", {
			app: app,
			type: type
		});
	}

	return {
		latest: latest
	};
};
